import { useEffect, useRef } from 'react';
import type { ReactMarkdownProps } from 'react-markdown/lib/complex-types';
import { useMediaMatch } from '../../../hooks/useMediaMatch';
import { TableCSS, media } from '../../../stylings';

export function Table({ children }: ReactMarkdownProps) {
  const isDesktop = useMediaMatch(media.greaterThan('lg'));
  const tableRef = useRef<HTMLTableElement>(null);

  useEffect(() => {
    if (!isDesktop && tableRef.current) {
      const thElements = tableRef.current.querySelectorAll('th');
      const thValues = Array.from(thElements).map((th) => th.textContent);
      const tdElements = tableRef.current.querySelectorAll('td');

      Array.from(tdElements).forEach((td, index) => {
        if (td.innerHTML.trim() === '') {
          // eslint-disable-next-line no-param-reassign
          td.innerHTML = '&nbsp;';
        }
        const thValue = thValues[index % thValues.length];
        td.setAttribute('data-label', thValue ?? '');
      });
    }
  }, [isDesktop, tableRef]);

  return (
    <>
      <TableCSS />
      <table ref={tableRef}>{children}</table>
    </>
  );
}
